import React, {useState } from 'react';
import { Redirect } from 'react-router-dom';


const RegisterModel = () => {

   async function createUser(firstname, lastname ,phonenumber, companyname , country,  email, password ){

        try{
            const res = await fetch('http://143.198.24.1:3000/api/user/create', {
            method: 'POST',
            headers: {'Content-Type':'application/json' },
            body:JSON.stringify( { "firstname":firstname, "lastname":lastname,"phone": phonenumber , "company_name": companyname ,"country":country , "email": email, "password":password } )
        });
            const userdata = await res.json();
            setDone(true);
            console.log(done);
            console.log(userdata);
        } catch(err){
            setWrong(true);
            console.log(wrong);
            console.log(err);
        }
    }

    const [state, setState] =useState({ firstname: undefined , lastname: undefined ,country: undefined ,companyname: undefined, phonenumber: undefined, email: undefined, password: undefined, confirmpassword: undefined });

    const [wrongpass, setWrongpass] =useState(false);
    const [wrong, setWrong] =useState(false);
    const [done , setDone] = useState(false);
    
    const handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
      setState(state => ( {...state, [name] : value} ));
    }

  

    const handleSubmit = (e) => {

        e.preventDefault();
        
        if(state.password !== state.confirmpassword)
        {
            setWrongpass(true); 
        }
        else
        {
            createUser( state.firstname , state.lastname , state.phonenumber , state.companyname , state.country ,  state.email , state.password   );
            setWrongpass(false);
        }


        if (done)
        { 
            return(
                <Redirect to={"/package"} />
            );  
        }

      }



    return(
        
        <div className="modal fade register-model" id="registerModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                        <div className="title-content">
                            <h3 className="model-title">تسجيل مستخدم جديد</h3>
                            <p className="model-subtitle">سجل الان واحصل على دراسة فورية</p>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6">
                                 <div className="form-group cassandra-form-group">
                                    <label>الاسم الأول</label>
                                    <input  className="form-control cassandra-form-control" name="firstname" value={state.firstname} onChange={handleChange}  type="text" placeholder="الاسم الأول"/>
                                 </div>
                                </div>
                                <div className="col-lg-6">
                                 <div className="form-group cassandra-form-group">
                                    <label>الاسم الأخير</label>
                                    <input  className="form-control cassandra-form-control" name="lastname" value={state.lastname} onChange={handleChange}  type="text" placeholder="الاسم الأخير"/>
                                 </div>
                                </div>
                                <div className="col-lg-6">
                                <div className="form-group cassandra-form-group">
                                    <label>رقم الجوال</label>
                                    <input  className="form-control cassandra-form-control" name="phonenumber" value={state.phonenumber} onChange={handleChange}  type="tel" placeholder="رقم الجوال"/>
                                 </div>
                                </div>
                                <div className="col-lg-6">
                                <div className="form-group cassandra-form-group">
                                    <label>اسم الشركة</label>
                                    <input  className="form-control cassandra-form-control" name="comapnyname" value={state.companyname} onChange={handleChange}  type="text" placeholder="اسم الشركة"/>
                                 </div>
                                </div>
                                <div className="col-lg-6">
                                 <div className="form-group cassandra-form-group">
                                    <label>البلد</label>
                                    <input  className="form-control cassandra-form-control" name="country" value={state.country} onChange={handleChange}  type="text" placeholder="البلد"/>
                                 </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group cassandra-form-group">
                                        <label>البريد الإلكترونى</label>
                                        <input  className="form-control cassandra-form-control" name="email" value={state.email} onChange={handleChange}  type="email" placeholder="البريد الالكتروني"/>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group cassandra-form-group">
                                        <label>كلمة المرور</label>
                                        <input  className="form-control cassandra-form-control" name="password" value={state.password} onChange={handleChange} autoComplete="newpassword" type="password" placeholder="كلمة المرور"/>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group cassandra-form-group">
                                        <label>تأكيد كلمة المرور</label>
                                        <input  className="form-control cassandra-form-control" name="confirmpassword" value={state.confirmpassword} onChange={handleChange} autoComplete="newpassword"  type="password" placeholder="تأكيد كلمة المرور"/>
                                    </div>
                                </div>
                            </div>
                                <div className="text-center">
                                <button className="submit-btn" type="button"  onClick={handleSubmit} > إنشاء حساب </button>
                                

                                  {
                                    wrongpass && 
                                    <div className="wrong-data" >كلمة المرور غير مطابقة </div>
                                  }

                                  {
                                    wrong && 
                                    <div className="wrong-data" >هذا الايميل مسجل لدينا من قبل يمكنك تسجيل الدخول </div>
                                  }
                                  
                                </div>
                         
                             

                        </form>
                    </div>
                </div>
            </div>
         </div>
    );

};
export default RegisterModel;
